import { createContext, useContext } from 'react';

import {
  IConfigOfferEntryDto,
  IRewardEntryDto,
  ISystemWideOfferEntryDto,
} from 'generated/graphql-gateway';

import {
  IIngredients,
  ILocalizedMenu,
  ILocalizedMenuEntry,
  IMainMenuNode,
  IndexedMenu,
} from './types';

export interface IUnifiedMenuContext {
  rawMenu: ILocalizedMenu | undefined;
  indexedMenu: IndexedMenu<ILocalizedMenuEntry>;
  indexedRewards: IndexedMenu<IRewardEntryDto>;
  indexedOffers: IndexedMenu<IConfigOfferEntryDto | ISystemWideOfferEntryDto>;
  mainMenu: IMainMenuNode[];
  isLoading: boolean;
  hasError: boolean;
  refetchMenu: () => Promise<void>;
  ingredients: IIngredients[] | undefined;
}

export const UnifiedMenuContext = createContext<IUnifiedMenuContext>({
  rawMenu: undefined,
  indexedMenu: IndexedMenu.EMPTY,
  indexedRewards: IndexedMenu.EMPTY,
  indexedOffers: IndexedMenu.EMPTY,
  mainMenu: [],
  isLoading: false,
  hasError: false,
  refetchMenu: async () => {
    return;
  },
  ingredients: undefined,
});
UnifiedMenuContext.displayName = 'UnifiedMenuContext';

export const useUnifiedMenuContext = (): IUnifiedMenuContext => {
  const context = useContext(UnifiedMenuContext);
  if (!context) {
    throw new Error('useUnifiedMenuContext must be used within a UnifiedMenuProvider');
  }
  return context;
};
